export default "__VITE_ASSET__15ssUydh__"